import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import InputQuesComponent from "./component/InputQuesComponent";
import QuesRequestComponent from "./component/QuesRequestComponent";
import QuesResponseComponent from "./component/QuesResponseComponent";
import SuggestionCard from "./component/SuggestionCard";
import { ThreeDots } from "react-loader-spinner";
import PageSEO from "../../components/SEO_Component/PageSEO";
import { CircularProgress } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { GrPowerReset } from "react-icons/gr";

const GPTpage = () => {
  //Functions for fetching using POST
  const [gptResponseData, setGptResponseData] = useState({});
  const [globalSuggestionsData, setGlobalSuggestionsData] = useState({});
  const [shouldShowSuggestions, setShouldShowSuggestions] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [chatlog, setChatLog] = useState([]);
  const [latestSuggestion, setLatestSuggestion] = useState([]);
  const [currentSuggestion, setCurrentSuggestion] = useState("");
  const [firstLoad, setFirstLoad] = useState(true);
  const [trackingId, setTrackingId] = useState("");
  const [userMessageSent, setUserMessageSent] = useState(false);

  const fetchGptResponse = async (input, uuid = "calculatetax_prompt") => {
    setLoading(true);
    setUserMessageSent(true);
    setChatLog((prevChatLog) => [
      ...prevChatLog,
      { type: "user", message: input },
    ]);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API}/api/v2/gpt`,

        {
          message: input,
          uuid: uuid,
          ln: "en",
        }
      );

      setTrackingId(response.data.tracking_id);

      setChatLog((prevChatLog) => [
        ...prevChatLog,
        { type: "bot", message: response.data.ai_response },
      ]);

      setLatestSuggestion(response.data.suggestions);

      setGptResponseData(response.data).then(() => {
        setLoading(false);
      });
    } catch (error) {
      setError(error);
      setLoading(false);
    }
  };
  const [primaryData, setPrimaryData] = useState({});
  const fetchPrimaryData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API}/english//fintragpt?debug=true`
      );
      setPrimaryData(response.data);
    } catch (error) {
      setError(error);
    }
    setLoading(false);
    setFirstLoad(false);
  };

  useEffect(() => {
    fetchPrimaryData();
  }, []);

  const massageEndRef = useRef(null);

  useEffect(() => {
    if (userMessageSent) {
      massageEndRef.current?.scrollIntoView();
      setUserMessageSent(false);
    }
  }, [userMessageSent]);

  return (
    <>
      {firstLoad && (
        <div className="w-[100vw] flex items-center justify-center h-full">
          <CircularProgress />
        </div>
      )}

      {!firstLoad && (
        <div className="text-black flex flex-col w-[100vw]">
          {primaryData.seo && (
            <div className=" text-[#00000094] md:text-2xl text-lg flex flex-col justify-center text-center font-montserrat font-semibold md:mb-4">
              <div className="flex bg-blue-900 text-white text-base py-1">
                <span className="flex-1">{primaryData.seo.h1}</span>
                {chatlog.length > 1 && (
                  <div
                    className="flex justify-center items-center mr-2"
                    onClick={() => {
                      setChatLog([]);
                      setLatestSuggestion([]);
                    }}
                  >
                    <AddIcon />
                  </div>
                )}
              </div>
            </div>
          )}
          {primaryData.seo && <PageSEO seoData={primaryData.seo} />}
          <div className="mb-24 pb-1 overflow-y-scroll scrollbar-hide md:w-[80%] w-[90%] mx-auto flex flex-col scroll-auto">
            {chatlog.length == 0 && primaryData.seo ? (
              <div className="flex-col">
                <div
                  className="flex justify-center text-black font-montserrat md:text-lg text-sm font-normal md:mt-4 mt-2"
                  dangerouslySetInnerHTML={{ __html: primaryData.seo.data }}
                ></div>
              </div>
            ) : (
              <>
                {chatlog.map((item, index) => {
                  if (item.type == "user") {
                    return (
                      <QuesRequestComponent
                        content={item.message}
                        key={index}
                      />
                    );
                  } else {
                    return (
                      <QuesResponseComponent
                        content={item.message}
                        key={index}
                        tracking_id={trackingId}
                        onComplete={(bool) => {
                          setShouldShowSuggestions(true);
                        }}
                      />
                    );
                  }
                })}
                <div ref={massageEndRef}></div>
              </>
            )}

            {loading ? (
              <ThreeDots
                height="40"
                width="40"
                radius="9"
                color="#1b4aef"
                ariaLabel="three-dots-loading"
                wrapperStyle={{}}
                wrapperClassName=""
                visible={true}
              />
            ) : (
              latestSuggestion &&
              latestSuggestion.length > 0 && (
                <div className="flex flex-col bg-[#f7f9fd] md:px-2 px-1 border-[#d5d7da] border-t-[1px]  items-start left-0 mr-1 rounded-b-lg pb-2 pt-1 md:max-w-[50%] max-w-[80%]">
                  {latestSuggestion.map((item, index) => (
                    <div
                      className="mx-1 my-1 cursor-pointer"
                      key={index}
                      onClick={() => {
                        {
                          document.getElementById("inputquery").focus();
                        }
                        setCurrentSuggestion(item);
                      }}
                    >
                      <SuggestionCard suggestion={item} isResponse={true} />
                    </div>
                  ))}
                </div>
              )
            )}
          </div>
          <div className="inset-x-0 bottom-0 fixed">
            <InputQuesComponent
              fetchGptResponse={fetchGptResponse}
              currentSuggestion={currentSuggestion}
              subtitle={primaryData?.seo?.subtitle ?? "subtitle here"}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default GPTpage;
